import { isProduction } from 'src/shared/utils/environment';

export const HomeownerBranchLink = isProduction()
  ? 'https://hover-home.app.link/start-scan'
  : 'https://hover-home.test-app.link/start-scan';

export const getDeepLink = (projectId?: string) =>
  projectId
    ? `${HomeownerBranchLink}?projectId=${projectId}`
    : HomeownerBranchLink;
